import { isNil } from 'lodash';
import { space, variant as styledVariant } from 'styled-system';
import styled from 'styled-components';

const dividerVariants = styledVariant({
  variants: {
    lightBackground: {
      backgroundColor: 'background',
    },
    darkBackground: {
      backgroundColor: 'backgroundDark',
    },
    lightGrey: {
      backgroundColor: 'rgb(246, 246, 246)',
    },
    darkGrey: {
      backgroundColor: 'grey100',
    },
    warmWhite: {
      backgroundColor: 'warmWhite3',
    },
    grey70: {
      backgroundColor: 'grey70',
    },
  },
});

const Divider = styled.div.attrs(({ variant }) => {
  const dividerVariant = isNil(variant) ? 'darkBackground' : variant;

  return { variant: dividerVariant };
})`
  ${space}
  width: ${({ width = '100%' }) => width};
  height: ${({ height = '1px' }) => height};
  ${dividerVariants}
  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor};`}
`;

export { Divider };
